

export const Fields = [
  "nomesede",
  "nomecelula",
  "nomeministerio",
  "bairro",
  "frequencia",
  "membros"
]


export const Headers = [
  "Campus",
  "Nome",
  "Tipo de PG",
  "Bairro",
  "Frequência",
  "Qtd. Participantes"
]
